import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {UserService} from '../user/user.service';
import {Store} from '../../models/store';
import {Household} from '../../models/household';
import {Context} from '../../models/context';
import { AppLogger, AppLoggerService } from '../../core/logging';

@Injectable({
  providedIn: 'root'
})
export class ContextStoreService {

  private readonly tag = '[ContextStore]';

  private readonly log: AppLogger;

  private readonly selectedHousehold = new BehaviorSubject<Household>({});
  private readonly selectedStore = new BehaviorSubject<Store>({});
  private readonly context = new BehaviorSubject<Context>(new Context());

  readonly household$ = this.selectedHousehold.asObservable();
  readonly store$ = this.selectedStore.asObservable();
  readonly context$ = this.context.asObservable();

  constructor(private userService: UserService, private appLogger: AppLoggerService) {
    this.log = this.appLogger.createForClass(ContextStoreService);
  }

  private _setSelectedHousehold(h: Household): void {
    this.selectedHousehold.next(h);
  }

  private _setSelectedStore(s: Store): void {
    this.selectedStore.next(s);
  }

  private _setContext(c: Context): void {
    this.context.next(c);
  }

  get selectedHouseholdValue(): Household {
    return this.selectedHousehold.getValue();
  }

  updateHouseholdSelection(h: Household): void {
    this._setSelectedHousehold(h);
    this._setContext(new Context(h));
    this.log.debug('Household selection changed', { householdId: h?.id, name: h?.name, isDefault: h?.is_default });
  }

  updateStoreSelection(h: Household, s: Store): void {
    this._setSelectedStore(s);
    this._setContext(new Context(h, s));
    this.log.debug('Store selection changed', {
      householdId: h?.id,
      storeId: s?.id,
      name: s?.name,
      isDefault: s?.is_default
    });
  }

}
